import { FunctionComponent, ReactNode } from 'react'
import {
  FacebookEmbed,
  InstagramEmbed,
  TikTokEmbed,
  XEmbed,
  YouTubeEmbed,
} from 'react-social-media-embed'
import styled from 'styled-components'
import ThreadsEmbed from '@/components/modal/social-media-post-modal/threads-embed'
import { PlatformCode } from '@/utils/convert-platform'

interface SocialMediaEmbedProps {
  platformCode: PlatformCode
  url: string
  width?: string | number
}

const SocialMediaEmbed: FunctionComponent<SocialMediaEmbedProps> = ({
  platformCode,
  url,
  width = '456px',
}) => {
  return (
    <Wrapper>
      {((): ReactNode => {
        switch (platformCode) {
          case PlatformCode.Twitter:
            return <XEmbed url={url} width={width} />
          case PlatformCode.Facebook:
            return <FacebookEmbed url={url} width={width} />
          case PlatformCode.Instagram:
            return <InstagramEmbed url={url} width={width} />
          case PlatformCode.TikTok:
            return <TikTokEmbed url={url} width={width} />
          case PlatformCode.YouTube:
            return <YouTubeEmbed height={360} url={url} width={width} />
          case PlatformCode.Threads:
            return <ThreadsEmbed url={url} width={width} />
          default:
            return <div>Not supported</div>
        }
      })()}
    </Wrapper>
  )
}

export default SocialMediaEmbed

const Wrapper = styled.div`
  iframe.instagram-media {
    margin: 0 !important;
  }
`
